<template>
  <single-panel-page>
    <div v-show="inProgress">
      <p>We are now activating your account ...</p>
      <loader />
    </div>

    <div v-show="!inProgress && activationDone" class="animated fadeIn">
      <p class="text-success">
        Congrats! You have successfully activated your access. You'd be
        redirected to showroom shortly.
      </p>
      <!--   <p class="text-muted">
        You can optionally use
        <router-link :to="{ name: 'login' }"> login page </router-link>.
      </p> -->
      <!-- <loader/> -->
    </div>

    <div v-show="!inProgress && !activationDone" class="animated fadeIn">
      <p v-show="userAlreadyActive" class="text-info">
        This link has been already used. Please use login page.
      </p>
      <router-link
        v-show="userAlreadyActive"
        :to="{ name: 'login' }"
        class="btn btn-primary"
      >
        Click to login
      </router-link>
      <p v-show="!userAlreadyActive" class="text-warning">
        There was an error during access activation. Please
        <a href="mailto:support@vestbee.com">contact us</a>
        if this repeats.
      </p>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { sleep } from '@/utils'
import { ref } from '@vue/composition-api'
import { getNewAppUrl } from '@/utils/urls'

export default {
  props: {
    userId: { type: String, default: null },
    eventId: { type: String, default: null },
    token: { type: String, default: null },
    privateToken: { type: String, default: null },
  },
  setup(props, { root }) {
    const inProgress = ref(true)
    const activationDone = ref(false)
    const userAlreadyActive = ref(false)

    async function scheduleRedirect() {
      const interval = setInterval(countdown, 1000)
      const userRequest = root.$store.dispatch('user/getUser')
      const eventId = props.eventId
      let secondsLeft = 3

      async function countdown() {
        secondsLeft -= 1
        if (secondsLeft === 0) {
          clearInterval(interval)
          await userRequest
          window.location = getNewAppUrl(`/dashboard/showrooms/${eventId}`)
        }
      }
    }

    const request = Auth.activateForShowroomPrivate({
      userId: props.userId,
      eventId: props.eventId,
      token: props.token,
      privateToken: props.privateToken,
    })

    ;(async () => {
      await sleep(1000)
      try {
        const response = await request
        activationDone.value = true
        inProgress.value = false
        Auth.storeToken(response.data.token)
        scheduleRedirect()
      } catch (error) {
        activationDone.value = false
        inProgress.value = false
        if (
          error.response.data.token &&
          error.response.data.token[0] ===
            'Wrong combination or token already used'
        ) {
          userAlreadyActive.value = true
        }
      }
    })()

    return {
      inProgress,
      activationDone,
      userAlreadyActive,
    }
  },
}
</script>
